module.exports = __webpack_public_path__ + "media/images/athletes/3385-7f6f14aa6ffb575ec2ae6d04d902bcc8.png";